import axios from 'axios';

type VersionData = {
  version: string;
};

const CURRENT_VERSION = import.meta.env.REACT_APP_VERSION || '';

const getVersionFileUrl = () => {
  const baseUrl = import.meta.env.BASE_URL.replace(/\/+$/, '');
  return `${baseUrl}/version.json`;
};

/**
 * Verifies current app version against server version, reloads if there's a new version
 */
const bust = async () => {
  // Skip version check in development environment
  if (import.meta.env.DEV) {
    return Promise.resolve();
  }

  try {
    const url = `${getVersionFileUrl()}?t=${Date.now()}`;
    const response = await axios.get<VersionData>(url);

    const latestVersion = response.data.version;
    if (latestVersion !== CURRENT_VERSION) {
      window.location.reload();
    }
  } catch (error) {
    console.error('Failed to fetch version data:', error);
  }
};

export default { bust, CURRENT_VERSION };
